import store from '../store/index'
//----------------------
// get desc detail cols
//----------------------
export default function getDescDetailCols({
  headings,
  filter_status,
  view_round = 0,
  cur_round = 0,
}) {
  // console.log("-----------------------");
  // console.log("IN getDescDetailCols");
  let colNumbers = []
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let maxCA = this_store.config.max_ca
  let maxCR = this_store.config.max_cr
  //------------------------
  // set field cols to show
  //------------------------
  let fields = [
    'image',
    'name',
    'player_name',
    'sub_status_image',
    'visibility_image',
    'fatigue_image',
    'surprise_image',
    'bleeding_image',
    'options_image',
    'markers_image',
    'fill_category_before',
    'category',
    'type',
    'race_name',
    'role',
    'dex',
    'ca',
    'cr',
    'damage_mod',
    'fill4',
    'sr',
    'sr_adj',
    'sr_roll',
    'roll_off',
    'rank',
    'fill1',
  ]

  if (
    (cur_round > 1 && view_round == cur_round) ||
    (cur_round >= 1 && view_round == cur_round + 1)
  ) {
    const fill1Index = fields.indexOf('fill1')

    fields.splice(
      fill1Index,
      0,
      'fill_last_action_before',
      'prev_round_action_image',
      'fill_last_action_after',
    )
  }
  //---------------------------------
  // load seq where active
  //---------------------------------
  if (filter_status) {
    fields.push('seq')
  }
  //--------------------------------
  // get headings idx for col names
  //--------------------------------
  for (let k = 0; k < fields.length; k++) {
    let idx = headings.findIndex((a) => a.field == fields[k])

    if (idx !== -1) {
      colNumbers.push(idx)
    }
  }
  return colNumbers
}
